<template>
<div class="chapter">
<div class="inner_page">
<div class="epigraphPage" id="epigraphpage">
<a id="page06">
</a><a id="page07">
<div class="epigraph">
<p class="epigraphText">No good deed goes unpunished.</p>
<p class="epigraphSource">—Clare Boothe Luce</p>
</div>
</a></div>
<a id="page07">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 004epigraphpage.vue?37f2e046